import React from "react";
import StarRating from "./StarRating";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
export default function ProductCard({ product ,onClick}) {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  return (
    <div className="p-4 grid grid-cols-12 gap-4  bg-white rounded-lg shadow-sm  items-center">
     <Link to={`/products/${product?._id}?ref=${userInfo?.address??""}`} className="col-span-4  bg-gray-50 rounded-md flex-shrink-0 flex items-center justify-center overflow-hidden"  onClick={onClick} >
        <img src={product?.image?.["url"]} alt={product?.name} className="object-cover w-full h-full" />
      </Link>


      <div className="col-span-8 flex flex-col items-start">
      <Link to={`/products/${product?._id}?ref=${userInfo?.address??""}`}  onClick={onClick} ><h3 className="text-sm font-semibold text-black block text-left m-0 hover:text-[--color-button-3] transition-all duration-150">{product.name}</h3></Link>

        <div className="flex items-center gap-2">
        <StarRating rate={product?.rating??0} />

          <span className="text-xs text-gray-400 ">({product?.numReviews ?? 0})</span>
        </div>


        <div className=" flex items-center gap-2">
          <span className="text-sm font-bold text-red-600 flex gap-2">
            <img src="/images/logoToken.png" style={{ width: 20 }} /> {product?.price?.toFixed(2)}
          </span>
         {product?.oldPrice &&  <span className="text-sm line-through text-gray-400  flex gap-2">
            <img src="/images/logoToken.png" style={{ width: 20 }} /> {product?.oldPrice?.toFixed(2)}
          </span>}
          {product?.oldPrice &&   <span className=" text-xs bg-green-100 text-green-800 font-semibold px-[5px] py-[1px] rounded">
            {product?.discount}%
          </span> }
        </div>
      </div>
    </div>
  );
}
